module.exports = __webpack_public_path__ + "img/file-protect.4ac17161.svg";